import React, { useContext } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useDepotService from '../../../app/services/hooks/useDepotService';

interface Props {
    depotId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const DepotSwitchChange = ({ depotId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeDepot, fetchingActiveDepot } = useDepotService();

    const active = (value: boolean) => {
        setChecked(value);

        activeDepot(depotId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={depotId} callback={active} />;
};

export default DepotSwitchChange;
